module.exports = __webpack_public_path__ + "img/78.ec6d8df7.svg";